"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rem = void 0;
var BASE = 16; // Base font-size as set on <html>, default is 16px in all browsers

var rem = function rem(px) {
  return "".concat(px / BASE, "rem");
};
exports.rem = rem;